import moment from "moment-timezone";
import { getFreeSlots } from "@/api/userApi.js";
export default {
  data() {
    return {
      selectedDate: null,
      selectedTime: '',
      slotList: [], // All Available Time Slot For Selected Date Range
      timeSlots: [],  // Available Time Slot On Selected day
      availableDateList: [], // All Available Date 
      isDisableIcon: true,
      currentDateRange: {
        startDate: new Date(),
        endDate: null,
        maxDate: new Date()
      },
      loading: false,
      calendarKey: 0,
      passEditData: false
    }
  },
  async mounted() {
    if (typeof window !== 'undefined') {
      if (this.passForm.selectedDate != '') {

        // Only preselect date for PC view
        if (!this.passForm.selectedDate && localStorage.getItem('isPc') == "true") {
          this.passForm.selectedDate = this.formatDate();
        }

        Object.assign(this, this.passForm);
        this.passEditData = true;  
        this.handleUpdateIcon();
        this.getNearestAvailableDate(this.slotList); 
      } else {        
        this.getTimeSlot();
      }         
      this.updateCalendarEvent();   
    }
  },
  props: {
    timezone: {
      type: String
    },  
    passForm: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    timezone(val) {
      this.getTimeSlot();
    },     
    'passForm.openTimeSlot': {
      handler(val, oldVal) {
        if(val == false)
          this.updateCalendarEvent();   
      },
      immediate: true
    }
  },
  methods: {    
    formatDate(date, fmt = 'YYYY-MM-DD') {
      if (!date) {
        return this.$moment().format(fmt);
      } else {
        return this.$moment(date).format(fmt);
      }
    },
    handleHeaderDate(date) {
      if (this.$refs.calendarRef) {
        this.$refs.calendarRef.selectDate(date);

        if (!this.selectedDate) return false;
        if (this.availableDateList.includes(this.formatDate(this.selectedDate))) {
          this.handleSelectedSlot(this.selectedDate, true);
        } else {
          const similarMonth = this.availableDateList.filter(d => {
            const date = new Date(d);
            return ( date.getFullYear() === this.selectedDate.getFullYear() &&  date.getMonth() === this.selectedDate.getMonth());
          });
          
          if (similarMonth.length > 0) {
            this.handleSelectedSlot(new Date(similarMonth[0]), true);    
          } else {
            this.$emit('handleUpdate', 'selectedTime', "");
            this.handleDateChange(this.selectedDate);
          }
        }
      }
    },
    getCalendarDay(data) {
      return data.split('-').pop();
    },      
    getCalendarTimeView(time){
      return time ? this.formatDate(new Date(time), "HH:mm A") : '-';
    }, 
    handleUpdateIcon() {
      const today = new Date();
      const currentDate = this.selectedDate ? new Date(this.selectedDate) : new Date();
      const isSimilarMonth = today.getFullYear() == (currentDate).getFullYear() && today.getMonth() == currentDate.getMonth();
      this.isDisableIcon = (this.formatDate(currentDate) == this.formatDate(today)) 
                          || ((this.formatDate(currentDate) < this.formatDate(today))) 
                          || isSimilarMonth; 
    },
    handleDateChange(data, clickAction) {
      const prevDate = new Date(this.selectedDate);
      this.selectedDate = data;

      this.handleUpdateIcon(); 
      if (this.formatDate(this.selectedDate) < this.formatDate(new Date())) {
        this.getNearestAvailableDate(this.slotList);
        return;
      }

      if (this.checkWithinRange()) {
        this.getNearestAvailableDate(this.slotList);
      } else {
        this.$emit('handleUpdate', 'selectedTime', "");
        this.getTimeSlot();
      }

      if (prevDate.getFullYear() != data.getFullYear() || prevDate.getMonth() != data.getMonth()) {
        this.getNearestAvailableDate(this.slotList);      
      }
      if(clickAction)
        this.$emit('handleUpdate', 'openTimeSlot', true);
    },     
    checkWithinRange() {
      return this.formatDate(this.currentDateRange.startDate) <= this.formatDate(this.selectedDate) 
          && this.formatDate(this.currentDateRange.endDate) >= this.formatDate(this.selectedDate)
    },
    handleSelectTimeFromList(data){
      this.selectedTime = data;      
      this.$emit('handleUpdate', 'selectedTime', data);
    },        
    async getTimeSlot() {
      this.loading = true;
      let range = this.getMonthlyDateRange(this.selectedDate || new Date());
      let currentEndDate = this.currentDateRange.endDate
      let endDate = null;

      if (range.endDate > currentEndDate) {
        this.currentDateRange.endDate = range.endDate;        
        
        // Only pull data from last pull list end date
        if (currentEndDate) {
          endDate = new Date(currentEndDate);
          endDate.setDate(endDate.getDate() + 1);
        }
      }
      await this.handleGetAvailableSlot(endDate || this.currentDateRange.startDate, this.currentDateRange.endDate, currentEndDate)
      this.loading = false;
    },    
    // get date range for the month
    getMonthlyDateRange(startDate) {
      const start = new Date(startDate)

      const end = new Date(
        start.getFullYear(),
        start.getMonth() + 1, 0, 23, 59, 59 )

      return {
        startDate: start,
        endDate: end
      }
    },
    // to show overall availability of the calendar
    async handleGetAvailableSlot(startDate, endDate) {
      const startUtc = moment.tz(startDate, this.timezone).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
      const endUtc = moment.tz(endDate, this.timezone).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]"); 
      const param = {
        starttime: startUtc,
        endtime: endUtc,
      }
      const res = await getFreeSlots(param);
      if (res.data.success) {
        const nowUtc = new Date();
        nowUtc.setUTCHours(nowUtc.getUTCHours() + 3);
        const prevSlotList = [...this.slotList];

        const newSlotList = res.data.data
          // 先过滤掉距离当前 UTC 时间 3 小时内的时段
          .filter((x) => new Date(x.start) > nowUtc)
          // 再进行时区转换
          .map((x) => ({
            start: this.utcToLocal(x.start, this.timezone, "YYYY-MM-DD HH:mm"),
            end: this.utcToLocal(x.end, this.timezone, "YYYY-MM-DD HH:mm"),
          }))
          // 去重（按 start）
          .filter(
            (slot, index, self) =>
              index === self.findIndex((x) => x.start === slot.start)
        );
        this.slotList = [...prevSlotList, ...newSlotList];      

        await this.getAllAvailableDate(this.slotList);
        this.getNearestAvailableDate(this.slotList);
      } else {
        this.slotList = [];
        this.timeSlots = [];
        this.$message.error(res.data.data);
      }
      this.$emit('handleUpdate', 'slotList', this.slotList);   
      this.$emit('handleUpdate', 'currentDateRange', this.currentDateRange);  
    },
    // process for actual selected day
    getNearestAvailableDate(data) {
      if (!this.selectedDate) return null;
      const selectedDateSlot = data.filter(x =>
        this.formatDate(x.start) === this.formatDate(this.selectedDate) &&
        x.start > this.formatDate(new Date(), "YYYY-MM-DD HH:mm"));

      if (selectedDateSlot.length > 0) {
        this.handleSelectedSlot(selectedDateSlot[0].start, false);        
      } else { // choose next available day for booking
        const nextAvailable = this.availableDateList.filter((date) => this.formatDate(date) > this.formatDate(this.selectedDate));
        
        if(nextAvailable.length > 0)
          this.handleSelectedSlot(nextAvailable[0], true);
        else {
          this.timeSlots = [];
        }
      }
    },   
    // Temporary disable; Select timeslot from existing slotList
    // handleSelectedSlot(date, refresh) {
    //   this.selectedDate = date; 
    //   this.$emit('handleUpdate', 'selectedDate', date);

    //   const nowUtc = new Date();        
    //   nowUtc.setUTCHours(nowUtc.getUTCHours() + 3);
    //   const currentDateTime = this.utcToLocal(nowUtc, this.timezone);
    //   const selectedTimeSlot = this.slotList.filter((x) =>
    //     this.formatDate(x.start, "YYYY-MM-DD") == this.formatDate(this.selectedDate, "YYYY-MM-DD") &&
    //     x.start > currentDateTime)
    //     .map((x) => {
    //         return {
    //           value: this.formatDate(x.start, "HH:mm A"),
    //           key: x.start,
    //         };
    //       })
    //       // 排序（按时间升序）
    //       .sort((a, b) => new Date(a.key) - new Date(b.key));

    //   this.timeSlots = selectedTimeSlot;
    //   if (refresh) {
    //     this.selectedDate = new Date(date);
    //     this.calendarKey++;   // to allow update calendar event without click event
    //     this.updateCalendarEvent();     
    //     this.handleUpdateIcon();     
    //   }
      
    //   if(this.passEditData == true && this.timeSlots.some(item => item.key === this.selectedTime)) {
    //     this.passEditData = false;
    //   } else {
    //     this.handleSelectTimeFromList(this.timeSlots.length > 0 ? this.timeSlots[0].key : ""); 
    //   }
    // },
    // pull for the actual timeslot for selected day 
    async handleSelectedSlot(date, refresh) {
      this.loading = true;
      this.selectedDate = date;      
      this.$emit('handleUpdate', 'selectedDate', date);
      const startUtcDay = moment.tz(date, this.timezone).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
      const endUtcDay = moment.tz(date, this.timezone).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]"); 
      const param = {
        starttime: startUtcDay,
        endtime: endUtcDay
      }
      const res = await getFreeSlots(param);
      if (res.data.success) {
        const nowUtc = new Date();
        nowUtc.setUTCHours(nowUtc.getUTCHours() + 3);
        this.timeSlots = res.data.data
          // 先过滤掉当前 UTC 时间 3 小时内的时段
          .filter((x) => new Date(x.start) > nowUtc)
          // 再做时区转换与格式化
          .map((x) => {
            const processDate = this.utcToLocal(new Date(x.start), this.timezone);
            return {
              value: this.formatDate(processDate, "HH:mm A"),
              key: processDate,
            };
          })
          // 排序（按时间升序）
          .sort((a, b) => new Date(a.key) - new Date(b.key));

        if (refresh) {
          this.selectedDate = new Date(date);
          this.calendarKey++;   // to allow update calendar event without click event
          this.updateCalendarEvent();     
          this.handleUpdateIcon();     
        }

        if(this.passEditData == true && this.timeSlots.some(item => item.key === this.selectedTime)) {
          this.passEditData = false;
        } else {
          this.handleSelectTimeFromList(this.timeSlots.length > 0 ? this.timeSlots[0].key : ""); 
        }
      } else {
        this.timeSlots = [];
        this.handleSelectTimeFromList(""); 
        this.$message.error(res.data.data);
      }      
      this.loading = false;
    },
    getAllAvailableDate(data) {
      
      const now = this.formatDate(new Date(), "YYYY-MM-DD HH:mm");
      const seen = new Set();

      this.availableDateList = (data || []).reduce((list, { start }) => {
        if (start <= now) return list;

        const formatted = this.formatDate(start);
        if (seen.has(formatted)) return list;

        seen.add(formatted);
        list.push(formatted);
        return list;
      }, []);
      
      // Only preselect date for PC View
      if (!this.selectedDate && localStorage.getItem('isPc') == "true" && this.availableDateList.length > 0) {
        this.selectedDate = this.availableDateList[0];
      }

      this.updateCalendarEvent();
      this.$emit('handleUpdate', 'availableDateList', this.availableDateList);  
    },
    utcToLocal(utcDateTime, tz) {
      return moment.utc(utcDateTime).tz(tz).format("YYYY-MM-DD HH:mm:ss")
    },
    disabledDate(data) {
      const inRange = this.formatDate(this.currentDateRange.endDate) >= this.formatDate(data);
      return new Date(data).getTime() < new Date().setHours(0, 0, 0, 0) || (!this.availableDateList.includes(this.formatDate(data)) && inRange);
    },
    // 日期没有在现有的 date range 里 
    checkOutOfRange(data) {
      return this.formatDate(data, "YYYY-MM-DD") > this.formatDate(new Date(this.currentDateRange.endDate), "YYYY-MM-DD");
    },
    // 之前的日期
    checkIsPastDate(data) {
      return this.formatDate(new Date(data), "YYYY-MM-DD") < this.formatDate(new Date(), "YYYY-MM-DD");
    },
    updateCalendarEvent() {
      // Disable and hide date
      this.$nextTick(() => {
        document.querySelectorAll('.el-calendar-table td').forEach(td => {
          const disabledCell = td.querySelector('.is-date-disabled')
          const pastDateCell = td.querySelector('.is-past-date')
          const notInRangeCell = td.querySelector('.not-in-range')
          const hideCell = td.querySelector('.is-other-month')
          if (disabledCell) {
            td.classList.add('is-date-disabled-td')
          } else {
            td.classList.remove('is-date-disabled-td')
          }

          if (pastDateCell) {
            td.classList.add('is-past-date-td')
          } else {
            td.classList.remove('is-past-date-td')
          }

          if (hideCell) {
            td.classList.add('is-other-month-td')
          } else {
            td.classList.remove('is-other-month-td')
          }

          if (notInRangeCell) {
            td.classList.add('not-in-range-td')
          } else {
            td.classList.remove('not-in-range-td')
          }
        })
      })
    },
    handleNext() {
      ["slotList", "timeSlots", "availableDateList"].map((key) => this.$emit('handleUpdate', key, this[key]));
      this.$emit('handleNext');
    },
  },
}